<template>
    <div class="masImg">
        <img :src="imgSrc" class="small" alt="" @click="enlargeBtn">
        <div class="enlarge" v-if="isShow">
            <div class="enlargeBox">
               <div class="boxFixed">
                    <p class="imgClose">
                        <i class="el-dialog__close el-icon el-icon-close" @click="imgCloseBtn"></i>
                    </p>
                    <div><img :src="imgSrc" alt=""></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['imgSrc'],
    data() {
        return {
            isShow:false
        };
    },
    methods: {
        enlargeBtn(){
            document.getElementsByTagName('body')[0].className = 'el-popup-parent--hidden'; 
            this.isShow=true
        },
        imgCloseBtn(value) {
            document.getElementsByClassName("el-popup-parent--hidden")[0].classList.remove("el-popup-parent--hidden");
            this.isShow=false
        }
    },
};
</script>
<style>
.imgClose{
    padding: 20px 20px 10px;
}
.enlarge i.el-dialog__close{
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
}
.masImg .small{
    border: 6px;
    width: 100%;
    height: 100%;
}
.enlargeBox {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background:rgba(0,0,0,.3);
    z-index:999;
    overflow: hidden;
}
.boxFixed{
    position: relative;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
    background: #FFF;
}
.boxFixed div{
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.boxFixed div img{
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: calc(90vh - 100px);
    margin: 0 auto;
}
</style>